import { AbilityBuilder, PureAbility } from "@casl/ability";
import {
  Actions,
  Subjects,
  PermissionsMap,
  Permissions,
} from "@shared/lib/casl/types";

export function EntityBaseAbilityBuilder(entityName?: Subjects) {
  return (permissions: Permissions) => {
    const { can, rules } = new AbilityBuilder<PureAbility<[Actions, Subjects]>>(
      PureAbility,
    );

    permissions?.forEach((permission) => {
      const subject = (entityName || permission.aclName) as Subjects;
      const permKey = permission.action as keyof typeof PermissionsMap;

      (PermissionsMap[permKey] || []).forEach((action) => {
        can(action as Actions, subject);
      });
    });

    return rules;
  };
}
